export default {
  NH: { name: 'Noord-Holland', slug: 'noord-holland' },
  ZH: { name: 'Zuid-Holland', slug: 'zuid-holland' },
  UT: { name: 'Utrecht', slug: 'utrecht' },
  NB: { name: 'Noord-Brabant', slug: 'noord-brabant' },
  FR: { name: 'Friesland', slug: 'friesland' },
  GR: { name: 'Groningen', slug: 'groningen' },
  DR: { name: 'Drenthe', slug: 'drenthe' },
  OV: { name: 'Overijssel', slug: 'overijssel' },
  GE: { name: 'Gelderland', slug: 'gelderland' },
  FL: { name: 'Flevoland', slug: 'flevoland' },
  ZE: { name: 'Zeeland', slug: 'zeeland' },
  LI: { name: 'Limburg', slug: 'limburg' },
  NL: { name: 'Heel Nederland', slug: 'nederland' },
  BQ: { name: 'Bonaire', slug: 'bonaire' },
}
